import { msrpWsUrl } from "@/config/api";
import EventEmitter from "events";
import { ReconnectionManager } from "../utils/reconnectionManager";
//const WebSocket = require('ws');

class ConnectionManager extends EventEmitter {
  static connections = new Map();
  constructor(endpoint) {
    console.log("constructing connection manager");
    super();
    this.packetParser = null;
    this.endpoint = endpoint;
    this.connections = ConnectionManager.connections;

    // Reconnection support
    this.reconnectionManager = new ReconnectionManager();
    this.connectionState = 'disconnected';
    this.currentProtocol = null;
    this.currentHost = null;
    this.currentPort = null;
    this.isManualDisconnect = false;
    this.debounceTimer = null;
  }

  setPacketParser(parser) {
    this.packetParser = parser;

    //emit job is to trigger named events
    if (this.packetParser) {
      this.packetParser.on("protocolSwitch", (message) => {
        this.emit("protocolSwitch", message);
      });

      this.packetParser.on("403", (rawMessage) => {
        this.emit("403", rawMessage);
      });

      this.packetParser.on("401", (rawMessage) => {
        this.emit("401", rawMessage);
      });

      this.packetParser.on("auth_200", (rawMessage) => {
        this.emit("auth_200", rawMessage);
      });

      this.packetParser.on("SEND", (message) => {
        this.emit("SEND", message);
      });
    }
  }

  openSocket(protocol, host, port, isReconnecting = false) {
    console.log("open socket", protocol, host, port, "isReconnecting:", isReconnecting);

    // Store connection details for reconnection
    this.currentProtocol = protocol;
    this.currentHost = host;
    this.currentPort = port;

    if (protocol === "ws") {
      console.log("connectionswew", this.connections);

      if (this.connections.size > 0) {
        this.endpoint.emit("socketOpened", protocol);
        return;
      }

      // Update connection state ONLY if not reconnecting
      // If reconnecting, keep the 'reconnecting' state
      if (!isReconnecting) {
        this.connectionState = 'connecting';
        this.emit("connectionStateChanged", 'connecting');
      }

      //native WebSocket API provided by the browser
      // const socket = new WebSocket(`ws://${host}:${port}`, "msrp");
      // const socket = new WebSocket(`ws://127.0.0.1:3457`, "msrp");

      
      
      const socket = new WebSocket(msrpWsUrl, "msrp");
      socket.onopen = () => {
        console.log(`Connected to ${host}:${port} using WebSocket`);
        console.log("connections after set", this.connections);
        this.connections.set(protocol, socket);

        console.log("connections array", this.connections);
        console.log("after", this.connections.size);

        // Update connection state
        this.connectionState = 'connected';
        this.emit("connectionStateChanged", 'connected');

        // Reset reconnection manager on successful connection
        this.reconnectionManager.reset();

        this.endpoint.emit("socketOpened", protocol);
      };

      socket.onmessage = (event) => {
        let data = event.data;

        // Check if the data is a Blob
        if (data instanceof Blob) {
          data
            .text()
            .then((text) => {
              console.log("Received WebSocket data as Blob, converted to text:", text);
              try {
                this.packetParser.parse(text);
              } catch (err) {
                console.error("Failed to parse MSRP message:", err);
              }
            })
            .catch((err) => {
              console.error("Error reading Blob data:", err);
            });
        } else {
          console.log("Received WebSocket data:", data);
          try {
            // Pass the data to the message parser directly if it's already a string
            this.packetParser.parse(data);
          } catch (err) {
            console.error("Failed to parse MSRP message:", err);
          }
        }
      };

      socket.onerror = (err) => {
        console.error(`WebSocket connection error:`, err);
        this.emit("error", new Error(`WebSocket connection error unexpectedly`));

        // Don't trigger reconnection here - let onclose handle it
      };

      socket.onclose = (event) => {
        console.log(`WebSocket closed: code=${event.code}, reason=${event.reason}, clean=${event.wasClean}`);

        // Emit connection closed event
        this.emit("connectionClosed", {
          code: event.code,
          reason: event.reason,
          wasClean: event.wasClean
        });

        // Check if this was a manual disconnect
        if (this.isManualDisconnect) {
          console.log("Manual disconnect - not reconnecting");
          this.connectionState = 'disconnected';
          this.emit("connectionStateChanged", 'disconnected');
          this.connections.delete(protocol);
          return;
        }

        // Start reconnection with debouncing
        this.startReconnection(protocol);
      };
    } else {
      console.error("Unsupported protocol:", protocol);
    }
  }

  // TODO: delete this after tests
  // openConnection(protocol, host, port) {
  //   if (protocol === "ws") {
  //     console.log("connectionsarr", this.connections);
  //     console.log("before", this.connections.length);

  //     if (this.connections.length > 0) {
  //       this.emit("connected", protocol);
  //       return;
  //     }

  //     //native WebSocket API provided by the browser
  //     const socket = new WebSocket("ws://127.0.0.1:3457", "msrp");
  //     socket.onopen = () => {
  //       console.log(`Connected to ${host}:${port} using WebSocket`);
  //       this.connections.set(protocol, socket);

  //       console.log("connections after set", this.connections);

  //       this.emit("connected", protocol);
  //     };

  //     socket.onmessage = (event) => {
  //       let data = event.data;

  //       // Check if the data is a Blob
  //       if (data instanceof Blob) {
  //         data
  //           .text()
  //           .then((text) => {
  //             console.log("Received WebSocket data as Blob, converted to text:", text);
  //             try {
  //               this.packetParser.parse(text);
  //             } catch (err) {
  //               console.error("Failed to parse MSRP message:", err);
  //             }
  //           })
  //           .catch((err) => {
  //             console.error("Error reading Blob data:", err);
  //           });
  //       } else {
  //         console.log("Received WebSocket data:", data);
  //         try {
  //           // Pass the data to the message parser directly if it's already a string
  //           this.packetParser.parse(data);
  //         } catch (err) {
  //           console.error("Failed to parse MSRP message:", err);
  //         }
  //       }
  //     };

  //     socket.onerror = (err) => {
  //       console.error(`WebSocket connection error:`, err);
  //     };

  //     socket.onclose = () => {
  //       console.log(`WebSocket connection closed`);
  //       this.connections.delete(protocol);
  //     };
  //   } else {
  //     console.error("Unsupported protocol:", protocol);
  //   }
  // }

  sendMessage(protocol, message) {
    console.log("connectionManager :: send message function is called");
    const socket = this.connections.get(protocol);
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(message);
      console.log("message sent successfully");
    } else {
      console.warn(`No active connection found for protocol ${protocol}`);
    }
  }

  closeConnection(protocol) {
    const socket = this.connections.get(protocol);
    if (socket) {
      // Mark as manual disconnect to prevent reconnection
      this.isManualDisconnect = true;

      socket.close();
      console.log(`${protocol} connection closed manually`);
      this.connections.delete(protocol);

      // Clear reconnection manager
      this.reconnectionManager.clearTimer();

      // Reset flag after a delay
      setTimeout(() => {
        this.isManualDisconnect = false;
      }, 1000);
    } else {
      console.warn(`No active connection found for protocol ${protocol}`);
    }
  }

  /**
   * Start reconnection with exponential backoff
   */
  startReconnection(protocol) {
    // Clear any existing debounce timer
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    // Debounce rapid reconnection attempts (500ms)
    this.debounceTimer = setTimeout(() => {
      this.attemptReconnection(protocol);
    }, 500);
  }

  /**
   * Attempt reconnection
   */
  attemptReconnection(protocol) {
    // Check if max retries reached
    if (this.reconnectionManager.isMaxRetriesReached()) {
      console.error("Max reconnection attempts reached");
      this.connectionState = 'offline';
      this.emit("connectionStateChanged", 'offline');
      this.emit("maxRetriesReached");
      this.connections.delete(protocol);
      return;
    }

    // Update state
    this.connectionState = 'reconnecting';
    this.emit("connectionStateChanged", 'reconnecting');

    // Schedule reconnection with exponential backoff
    this.reconnectionManager.scheduleReconnect(() => {
      console.log(`Reconnection attempt ${this.reconnectionManager.getAttemptCount()}/${this.reconnectionManager.getMaxRetries()}`);

      // Emit reconnecting event with details
      this.emit("reconnecting", {
        attempt: this.reconnectionManager.getAttemptCount(),
        maxRetries: this.reconnectionManager.getMaxRetries(),
        nextRetryIn: 0 // Already retrying
      });

      // Remove old socket from connections
      this.connections.delete(protocol);

      // Attempt to reconnect using stored connection details
      // Pass isReconnecting = true to keep 'reconnecting' state
      this.openSocket(
        this.currentProtocol,
        this.currentHost,
        this.currentPort,
        true // isReconnecting
      );
    });
  }

  /**
   * Manual reconnect (reset retry counter)
   */
  manualReconnect() {
    console.log("Manual reconnect triggered");
    this.reconnectionManager.reset();
    this.isManualDisconnect = false;

    if (this.currentProtocol) {
      // Set state to reconnecting before attempting
      this.connectionState = 'reconnecting';
      this.emit("connectionStateChanged", 'reconnecting');

      this.connections.delete(this.currentProtocol);
      // Pass isReconnecting = true to keep 'reconnecting' state
      this.openSocket(
        this.currentProtocol,
        this.currentHost,
        this.currentPort,
        true // isReconnecting
      );
    }
  }

  /**
   * Get current connection state
   */
  getConnectionState() {
    return this.connectionState;
  }
}

export default ConnectionManager;
